import request from '@/utils/request'

//个人信息查询
export const profile = () => {
    return request({
        url: '/system/user/profile',
        method: 'get',
    })
}

//根据客户账号查询客户公司信息
export const selectClientByUserName = () => {
    return request({
        url: '/hqprotal/information/selectClientByUserName',
        method: 'post',
    })
}

//根据工厂账号查询工厂公司信息
export const selectPlantByUserName = () => {
    return request({
        url: '/hqprotal/manage/selectPlantByUserName',
        method: 'post',
    })
}

//完善客户个人信息
export const completeInformation = (data) => {
    return request({
        url: '/hqprotal/information/completeInformation',
        method: 'post',
        data
    })
}

//完善工厂信息
export const plantInformation = (data) => {
    return request({
        url: '/hqprotal/manage/completeInformation',
        method: 'post',
        data
    })
}

//个人中心修改密码
export const updatePwd = (params) => {
    return request({
        url: '/system/user/profile/updatePwd',
        method: 'put',
        params
    })
}

//个人中心查看意向单列表
export const selectClientIntentionList = (params) => {
    return request({
        url: '/hqprotal/intent/selectClientIntentionList',
        method: 'get',
        params
    })
}

//获取客户意向单的详情信息
export function getDetailsData(params) {
    return request({
        url: `/hqprotal/intent/getDetailsData/`,
        method: 'get',
        params
    })
}

//查询消息通知列表
export function messageList(params) {
    return request({
        url: `/hqprotal/msgnoticeRecord/list`,
        method: 'get',
        params
    })
}

//标记已读
export function updRecordData(data) {
    return request({
        url: `/hqprotal/msgnoticeRecord/updRecordData`,
        method: 'put',
        data
    })
}

